"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import { Wallet01Icon } from "@hugeicons-pro/core-solid-rounded";
import type { FC } from "react";
import CurrencyDropdownItem from "./CurrencyDropdownItem";
import type { LabeledCurrencyItem } from "./getCurrencyDropdownData";

type Props = {
  items: LabeledCurrencyItem[];
  activeCurrency: string;
  onSelect: (item: LabeledCurrencyItem) => void;
  noBalancesTitle: string;
  noBalancesSubtitle: string;
  isUbtcEnabled: boolean;
};

const CurrencyDropdownList: FC<Props> = ({
  items,
  activeCurrency,
  onSelect,
  noBalancesTitle,
  noBalancesSubtitle,
  isUbtcEnabled,
}) => {
  if (items.length === 0) {
    return (
      <div className="flex flex-col items-center gap-3 px-1 py-8 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-foreground/10">
          <HugeiconsIcon
            icon={Wallet01Icon}
            size={28}
            className="text-muted-foreground"
          />
        </div>
        <div className="flex flex-col gap-1">
          <span className="text-xl font-semibold">{noBalancesTitle}</span>
          <span className="text-base text-muted-foreground">
            {noBalancesSubtitle}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex max-h-[500px] flex-col gap-1 overflow-auto">
      {items.map((item) => (
        <CurrencyDropdownItem
          key={item.id}
          item={item}
          isActive={item.currency === activeCurrency}
          onSelect={onSelect}
          isUbtcEnabled={isUbtcEnabled}
        />
      ))}
    </div>
  );
};

export default CurrencyDropdownList;
